<template>
  <dd-drawer
    width="1000"
    @ok="visible = false"
    :closable="false"
    :cancelText="null"
    :visible="visible"
    @close="visible = false"
    :title="taskList ? 'Takenreeks: ' + taskList.name : 'Laden'"
  >
    <dd-card nested>
      <div class="flex-col gap-lg" v-if="!loading && taskList">
        <strong class="color-danger" v-if="taskList.stopped_at !== null">
          Deze takenreeks is gestopt.
        </strong>
        <p v-if="taskList.taskListItems.data.length === 0">
          Deze takenreeks heeft geen taken.
        </p>
        <dd-card
          v-else
          v-for="(task_list_item, index) in taskList.taskListItems.data"
          :key="task_list_item.id"
        >
          <div class="flex-row justify-content-between">
            <h3>
              {{ task_list_item.name }}
            </h3>
            <p>Taak {{ index + 1 }}</p>
          </div>
          <dd-card-stacked-list>
            <dd-card-list-row>
              <dd-card-list-item title="Datum">
                <span v-if="task_list_item.task">
                  {{ task_list_item.task.date | toDate }}
                </span>
                <span v-else-if="task_list_item.date > 0">
                  {{ task_list_item.date }} dagen na afronden van vorige taak
                </span>
                <span v-else> direct na afronden van vorige taak </span>
              </dd-card-list-item>
              <dd-card-list-item title="Beschrijving">
                {{ task_list_item.description || "Niet bekend" }}
              </dd-card-list-item>
            </dd-card-list-row>
            <dd-card-list-row>
              <dd-card-list-item title="Gebruiker(s)">
                {{
                  task_list_item.users
                    .map((user) => user.fullname)
                    .join(", ") || "Geen gebruikers gekoppeld"
                }}
              </dd-card-list-item>
              <dd-card-list-item title="Afdeling(en)">
                {{
                  task_list_item.user_departments
                    .map((department) => department.fullname)
                    .join(", ") || "Geen afdelingen gekoppeld"
                }}
              </dd-card-list-item>
            </dd-card-list-row>
            <dd-card-list-row>
              <dd-card-list-item title="Status">
                <a-tag
                  class="mt-ms"
                  v-if="task_list_item.task && task_list_item.task.status === 0"
                  color="blue"
                >
                  actief
                </a-tag>
                <a-tag
                  v-else-if="
                    task_list_item.task && task_list_item.task.status === 1
                  "
                  color="green"
                >
                  afgerond
                </a-tag>
                <a-tag v-else-if="taskList.stopped_at !== null" color="red">
                  geannuleerd
                </a-tag>
                <a-tag v-else color="grey">ingepland</a-tag>
              </dd-card-list-item>
              <dd-card-list-item title="Product label(s)">
                {{
                  task_list_item.product_labels
                      .map((label) => label.name)
                      .join(", ") || "Geen product label gekoppeld"
                }}
              </dd-card-list-item>
            </dd-card-list-row>
          </dd-card-stacked-list>
        </dd-card>
        <div>
          <dd-button
            @click="stopTaskList"
            type="danger"
            v-if="taskList.stopped_at === null"
          >
            Stop takenreeks
          </dd-button>
        </div>
      </div>
      <dd-loading-indicator v-else></dd-loading-indicator>
    </dd-card>
  </dd-drawer>
</template>

<script>
import taskListApi from "~/api/task_list";

export default {
  data() {
    return {
      taskList: null,
      visible: false,
      loading: false,
    };
  },

  mounted() {},

  methods: {
    async fetchTaskList(taskListId) {
      try {
        this.loading = true;
        let response = await taskListApi.get(taskListId);

        this.taskList = response.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    viewTaskList(taskList) {
      if (typeof taskList === "number") {
        this.fetchTaskList(taskList);
      } else {
        this.taskList = taskList;
      }

      this.visible = true;
    },
    async stopTaskList() {
      try {
        this.loading = true;
        let response = await taskListApi.destroy(this.taskList.id);

        this.taskList = response.data;
        this.$emit("update", this.taskList);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped></style>
